/**
 * Collapses a pathname to the page it belongs to.
 *
 * A product detail URL (/products/:slug) is the catalogue page with its
 * drawer open, not a separate page. Both the route-fade remount key and
 * ScrollToTop key off this, so opening or closing a drawer neither replays
 * the page transition nor throws away the visitor's place in the grid.
 */
const routeKey = (pathname) =>
  pathname.startsWith("/products") ? "/products" : pathname;

export default routeKey;
